<!-- Profile -->
<script>
import Errors from "../shared/components/errors-page/errors.vue";
export default {
  data() {
    return {
      networkError: false,
      error: false,
      error401: false,
      error500: false,
      errorOther: false,
      isLoading: false,
      userName: "",
      options: [
        {
          iconName: 'far fa-plus-circle',
          optionName: this.$tc("message.profileOptions", 0),
          id: 2,
        },
        {
          iconName: 'far fa-history',
          optionName: this.$tc("message.profileOptions", 1),
          id: 1,
        },
      ],
    };
  },
  components: {
    Errors
  },
  mounted() {
    this.userName = this.$store.getters.userName;
  },
  methods: {
    gotoNext(name) {
      if (name === this.$tc("message.profileOptions", 1)) {
        this.$router.push(`/transactions`);
      } else {
        // As we are only dependent on Province from member profile, this validation covers it.
        if (this.$store.state.province) {
          this.$router.push(`/`);
        } else {
          this.$toast.open({
            message: this.$t('message.provinceValidation'),
            type: 'error',
            position: 'top-right'
          })
        }
      }
    },
  },
  created() {
    if (navigator.onLine) {
      this.networkError = false;
      this.error = false;
    } else {
      this.error = true;
      this.networkError = true;
    }
  },
  name: "profile",
};
</script>

<!-- Template -->
<template>
  <fragment>
    <div v-if="!error" class="container-fluid">
      <div class="row justify-content-center">
        <div class="col-lg-8 col-md-12 col-sm-12">
          <div class="profile-container bg-white">
            <h3 class="user-name-title">
              {{ $tc("message.profileOptions", 2) }}, {{ userName }}
            </h3>
            <p class="question-title pb-0">
              {{ $tc("message.profileQuestext", 1) }}
            </p>
            <div class="row button-container">
              <b-col
                lg="6"
                md="6"
                sm="8"
                class="align-self-center"
                v-for="option in options"
                :key="option.id"
                @click="gotoNext(option.optionName)"
              >
                <div
                  class="profile-card border border-warning bg-warning text-center"
                >
                  <em class="icons" :class="option.iconName"></em>
                  <p class="option-text mb-2">
                    {{ option.optionName }}
                  </p>
                </div>
              </b-col>
            </div>
          </div>
        </div>
      </div>
    </div>
    <loader v-if="isLoading === true"></loader>
    <errors
      v-else
      :errorNetworkrErrorprops="this.networkError"
      :error401props="this.error401"
      :error500props="this.error500"
      :errorOtherprops="this.errorOther"
    ></errors>
  </fragment>
</template>

<!-- Style -->
<style lang="scss" scoped>
.profile-container {
  padding-top: 60px;
}
.icons {
  color: var(--secondary-bg-text) !important;
}
.bg-warning {
  background: var(--secondary-bg) !important;
  color: var(--secondary-bg-text) !important;
}
.bg-warning:hover {
  background: var(--button-hover-bg) !important;
  color: var(--button-hover-bg-text) !important;
}
.profile-container .row {
  margin-left: 0px;
  margin-right: 0px;
}
.profile-card {
  padding: 22px 21px;
  margin-bottom: 20px;
  box-sizing: border-box;
  border-radius: 6px;
  cursor: pointer;
  flex-direction: column;
  justify-content: center;
}
.user-name-title {
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 32px;
  text-align: center;
}
.question-title {
  font-style: normal;
  font-size: 16px;
  line-height: 150%;
  text-align: center;
  padding: 12px 0px;
}
.option-text {
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
  text-align: center;
}
.button-container {
  display: flex;
  flex-direction: column;
}
.vectorimg {
  max-height: 30px;
  max-width: 30px;
  margin-bottom: 14px;
  align-self: center;
}

@media (max-width: 600px) {
  .profile-card {
    margin-bottom: 16px;
  }
}
.icons {
  color: var(--danger);
  font-size: 25px;
}
</style>